import React from "react";
import LegalLayout from "./LegalLayout";

const PrivacyPolicy = () => (
  <LegalLayout
    testid="page-privacy-policy"
    eyebrow="Documento legale"
    title="Informativa sulla Privacy"
    updated="Ottobre 2026"
  >
    <p>
      La presente informativa descrive le modalità di trattamento dei dati personali degli utenti
      che consultano ed utilizzano il sito <strong>LEOVERA Nutrition</strong>, ai sensi del
      Regolamento (UE) 2016/679 ("GDPR") e del D.lgs. 196/2003 come novellato dal D.lgs. 101/2018.
    </p>

    <h2>1. Titolare del trattamento</h2>
    <p>
      Titolare del trattamento è <strong>LEOVERA Nutrition di Davide Allibrio</strong>,
      P.IVA 02155960897, REA SR-472359, con sede legale in Viale Tunisi 68, Siracusa,
      PEC: d.allibriopec@pec.it. Per qualsiasi richiesta relativa ai tuoi dati personali puoi
      contattarci all'indirizzo email <strong>info@leoveranutrition.it</strong>.
    </p>

    <h2>2. Dati personali trattati</h2>
    <ul>
      <li><strong>Dati identificativi e di contatto</strong>: nome, cognome, email, numero di telefono, indirizzo di spedizione.</li>
      <li><strong>Dati di autenticazione</strong>: email e password (memorizzata in forma cifrata con algoritmo bcrypt).</li>
      <li><strong>Dati d'ordine</strong>: articoli acquistati, importi, provincia di consegna, cronologia consegne.</li>
      <li><strong>Dati di navigazione</strong>: indirizzo IP, cookie tecnici, log di accesso (per finalità di sicurezza).</li>
      <li><strong>Dati facoltativi</strong>: preferenze di prodotto e comunicazioni marketing (solo se autorizzate).</li>
    </ul>

    <h2>3. Finalità e base giuridica</h2>
    <ul>
      <li><strong>Esecuzione del contratto</strong> (art. 6.1.b GDPR): gestione ordini, spedizioni, assistenza post-vendita, area utente e programma fedeltà "Cashback Elite".</li>
      <li><strong>Obblighi di legge</strong> (art. 6.1.c GDPR): fatturazione elettronica, contabilità, adempimenti fiscali.</li>
      <li><strong>Consenso</strong> (art. 6.1.a GDPR): invio di comunicazioni marketing, newsletter e codici sconto personalizzati; cookie di analisi e marketing.</li>
      <li><strong>Legittimo interesse</strong> (art. 6.1.f GDPR): sicurezza del sito, prevenzione delle frodi e miglioramento del servizio.</li>
    </ul>

    <h2>4. Modalità di trattamento e conservazione</h2>
    <p>
      I dati sono trattati con strumenti elettronici, adottando misure tecniche e organizzative
      adeguate (crittografia in transito TLS, hash bcrypt delle password, controlli d'accesso e
      backup cifrati). I dati sono conservati per il tempo strettamente necessario alle finalità
      dichiarate: dati d'ordine e fiscali per 10 anni ai fini di legge, dati marketing fino a
      revoca del consenso, log di sicurezza per un massimo di 12 mesi.
    </p>

    <h2>5. Comunicazione a terzi</h2>
    <p>
      I dati possono essere comunicati, esclusivamente per le finalità sopra indicate, a:
    </p>
    <ul>
      <li>corrieri e vettori per l'evasione delle spedizioni;</li>
      <li>fornitori di servizi di pagamento (es. <strong>Stripe</strong>) come titolari autonomi;</li>
      <li>consulenti fiscali e contabili;</li>
      <li>provider di hosting e infrastruttura cloud (in qualità di responsabili del trattamento).</li>
    </ul>
    <p>
      I dati non vengono ceduti né venduti a terzi per finalità autonome di marketing.
    </p>

    <h2>6. Trasferimenti extra-UE</h2>
    <p>
      Eventuali trasferimenti verso Paesi al di fuori dello Spazio Economico Europeo avvengono
      esclusivamente in presenza di garanzie adeguate previste dagli artt. 44-49 GDPR (Clausole
      Contrattuali Standard o decisioni di adeguatezza della Commissione Europea).
    </p>

    <h2>7. Diritti dell'interessato</h2>
    <p>
      In ogni momento puoi esercitare i diritti previsti dagli artt. 15-22 GDPR:
    </p>
    <ul>
      <li>accesso, rettifica e cancellazione dei tuoi dati;</li>
      <li>limitazione e opposizione al trattamento;</li>
      <li>portabilità dei dati;</li>
      <li>revoca del consenso in qualsiasi momento (senza pregiudicare la liceità del trattamento pregresso);</li>
      <li>reclamo all'Autorità Garante per la protezione dei dati personali (<a href="https://www.garanteprivacy.it" target="_blank" rel="noreferrer">garanteprivacy.it</a>).</li>
    </ul>
    <p>
      Per esercitare i diritti scrivi a <strong>info@leoveranutrition.it</strong>.
    </p>

    <h2>8. Chat con l'assistente virtuale</h2>
    <p>
      Il sito offre un assistente di acquisto virtuale ("Leo") basato su un servizio di
      intelligenza artificiale fornito da terze parti. I messaggi che scrivi nella chat vengono
      elaborati da questo servizio esclusivamente per generare le risposte e per aiutarti nella
      scelta dei prodotti e nel completamento dell'ordine. Il contenuto delle conversazioni
      viene conservato per il tempo necessario a gestire la conversazione stessa, l'eventuale
      ordine collegato e per finalità di assistenza e sicurezza. Le risposte dell'assistente
      sono generate automaticamente, hanno carattere puramente indicativo/commerciale e non
      costituiscono in alcun caso parere medico, nutrizionale o professionale.
    </p>

    <h2>9. Minori</h2>
    <p>
      Il sito e i prodotti sono destinati a un pubblico maggiorenne. Non trattiamo consapevolmente
      dati di minori di 16 anni senza il consenso dei genitori o di chi esercita la responsabilità
      genitoriale.
    </p>

    <h2>10. Modifiche</h2>
    <p>
      La presente informativa può essere aggiornata: la versione in vigore è sempre pubblicata su
      questa pagina con l'indicazione della data di ultima modifica.
    </p>
  </LegalLayout>
);

export default PrivacyPolicy;
